import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { fetchAttributionReport } from "../../../services/automapAttributionApi";
import { trackAttributionEvent } from "../../../utils/campaignAttributionAnalytics";
import { AdminAnalyticsNav } from "./AdminAnalyticsShared";

const RANGE_OPTIONS = [
  { value: "today", label: "Hoy" },
  { value: "last_7_days", label: "Últimos 7 días" },
  { value: "last_30_days", label: "Últimos 30 días" },
  { value: "this_month", label: "Este mes" },
];

function BreakdownTable({ title, rows, keyLabel = "Clave" }) {
  if (!rows?.length) return null;
  return (
    <section className="dealer-state-box">
      <h3>{title}</h3>
      <table className="dealer-inventory-table">
        <thead>
          <tr>
            <th>{keyLabel}</th>
            <th>Leads</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td>{row.key}</td>
              <td>{row.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export default function AdminAttributionPage() {
  const [range, setRange] = useState("last_30_days");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchAttributionReport(range)
      .then((data) => {
        setPayload(data);
        trackAttributionEvent("attribution_report_viewed", { range });
      })
      .catch((err) => setError(err.message || "Error al cargar atribución."))
      .finally(() => setLoading(false));
  }, [range]);

  const report = payload?.report;
  const totals = report?.totals;

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Atribución"
        title="Atribución de campañas"
        description="Leads por fuente, campaña, landing page y tipo de página."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="attribution" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <label>
            Periodo
            <select
              value={range}
              onChange={(e) => {
                setRange(e.target.value);
                trackAttributionEvent("attribution_filter_changed", { range: e.target.value });
              }}
            >
              {RANGE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        {error ? <p className="import-error">{error}</p> : null}
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {!loading && report ? (
          <>
            <div className="dashboard-summary-grid">
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">Leads</span>
                <strong className="dashboard-summary-value">{totals.leads}</strong>
              </div>
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">Calientes</span>
                <strong className="dashboard-summary-value">{totals.hotLeads}</strong>
              </div>
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">Quiz</span>
                <strong className="dashboard-summary-value">{totals.quizCompletions}</strong>
              </div>
              <div className="dashboard-summary-card">
                <span className="dashboard-summary-label">WhatsApp</span>
                <strong className="dashboard-summary-value">{totals.whatsappClicks}</strong>
              </div>
            </div>

            <BreakdownTable title="Leads por fuente / medio" rows={report.bySourceMedium} />
            <BreakdownTable title="Leads por campaña" rows={report.byCampaign} />
            <BreakdownTable title="Leads por landing page" rows={report.byLandingPage} keyLabel="Landing" />
            <BreakdownTable title="Leads por tipo de página" rows={report.byPageType} keyLabel="Tipo" />
            <BreakdownTable title="Leads por SEO page type" rows={report.bySeoPageType} keyLabel="SEO type" />
            <BreakdownTable title="Leads por guía" rows={report.byGuide} keyLabel="Guía" />
            <BreakdownTable title="Quiz por fuente" rows={report.quizBySource} />
            <BreakdownTable title="WhatsApp por fuente" rows={report.whatsappBySource} />
            <BreakdownTable title="Leads calientes por fuente" rows={report.hotBySource} />
            <BreakdownTable title="Leads malos por fuente" rows={report.badBySource} />

            <section className="dealer-state-box">
              <h3>Leads recientes con atribución</h3>
              <table className="dealer-inventory-table">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Comprador</th>
                    <th>Fuente</th>
                    <th>Medio</th>
                    <th>Campaña</th>
                    <th>Conversión</th>
                  </tr>
                </thead>
                <tbody>
                  {report.recentLeads.map((lead) => (
                    <tr key={lead.id}>
                      <td>{new Date(lead.createdAt).toLocaleString("es-CO")}</td>
                      <td>{lead.buyerName}</td>
                      <td>{lead.source}</td>
                      <td>{lead.medium}</td>
                      <td>{lead.campaign || "—"}</td>
                      <td>{lead.conversionPage || lead.conversionPageType || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
